import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import KioskConfigScreen from '../KioskConfigScreen/KioskConfigScreen';
import MobileConfigScreen from '../MobileConfigScreen/MobileConfigScreen';
import WebConfigScreen from '../WebConfigScreen/WebConfigScreen';
import consumerChannelsConfigStore from './store';
import { SCREENS } from 'src/constants/screens';
import CustomRoute from 'src/view/components/CustomRoute/CustomRoute';
import LoadingOverlay from 'src/view/components/LoadingOverlay/LoadingOverlay';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import { appStore } from '~/mobx/appStore';
import DookConfigScreen from '~/view/screens/SettingsScreen/screens/OrderingChannel/screens/DookConfigScreen/DookConfigScreen';

const ConsumerChannelsConfigScreen: FC = observer((): JSX.Element => {
  useEffect(() => {
    consumerChannelsConfigStore.fetchParams();

    return () => consumerChannelsConfigStore.clearStore();
  }, []);

  const isRedirectPath: string = appStore.isAddonsAvailable.mobileApp
    ? SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_MOBILE()
    : SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_WEB();

  return (
    <div className="d-flex flex-column flex-1">
      <Headers>
        <HeaderBack title="consumer_channel_configuration" path={SCREENS.SETTINGS()} isBeta />
      </Headers>

      <Switch>
        <Route exact path={SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG()}>
          <Redirect to={isRedirectPath} />
        </Route>

        <CustomRoute
          exact
          path={SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_MOBILE()}
          component={MobileConfigScreen}
          access={appStore.isAddonsAvailable.mobileApp}
        />
        <CustomRoute exact path={SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_WEB()} component={WebConfigScreen} />
        <CustomRoute
          exact
          path={SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_KIOSK()}
          component={KioskConfigScreen}
          access={appStore.isAddonsAvailable.kiosk}
        />
        <CustomRoute exact path={SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_DOOK()} component={DookConfigScreen} />
      </Switch>

      <LoadingOverlay visible={consumerChannelsConfigStore.isLoading} refreshing />
    </div>
  );
});

export default ConsumerChannelsConfigScreen;
